import * as actionTypes from '@store/actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  success: false,
  email: ''
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FORGOT_PASSWORD_RESET:
      return {
        ...state,
        error: null,
        loading: false,
        success: false
      };

    case actionTypes.FORGOT_PASSWORD_START:
      return {
        ...state,
        error: null,
        loading: false
      };
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        success: true
      };
    case actionTypes.FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case actionTypes.FORGOT_PASSWORD_HASH_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        success: false,
        email: action.email
      };
    default:
      return state;
  }
};

export default reducer;
